/**
 * Color 字典数据
 *
 * 字典数据来源 [A nicer color palette for the web](http://clrs.cc/)
 */
export default {
  navy: '#001F3F',
  blue: '#0074D9',
  aqua: '#7FDBFF',
  teal: '#39CCCC',
  olive: '#3D9970',
  green: '#2ECC40',
  lime: '#01FF70',
  yellow: '#FFDC00',
  orange: '#FF851B',
  red: '#FF4136',
  maroon: '#85144B',
  fuchsia: '#F012BE',
  purple: '#B10DC9',
  silver: '#DDDDDD',
  gray: '#AAAAAA',
  black: '#111111',
  white: '#FFFFFF',
};
